import { Link } from 'react-router-dom';

const seoArticles = [
  {
    slug: '/guida-itaobuy-sheet-2026',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20product%20research%20workspace%20with%20minimalist%20fashion%20items%20and%20spreadsheet%20on%20light%20oak%20desk%2C%20soft%20natural%20light%2C%20editorial%20photography%2C%20clean%20professional%20composition&width=600&height=340&seq=seo-card-01&orientation=landscape',
    title: 'Guida Itaobuy Sheet 2026: come trovare prodotti in modo intelligente',
    excerpt: 'Scopri come utilizzare al meglio Itaobuy Spreadsheet per organizzare le tue ricerche, confrontare prodotti e prendere decisioni di acquisto più consapevoli.',
    badge: 'Guida Completa',
  },
  {
    slug: '/guida-sicurezza-itaobuy',
    image: 'https://readdy.ai/api/search-image?query=Secure%20online%20shopping%20concept%20with%20padlock%20symbol%20and%20product%20images%20on%20warm%20cream%20background%2C%20soft%20lighting%2C%20trustworthy%20editorial%20style&width=600&height=340&seq=seo-card-02&orientation=landscape',
    title: 'Itaobuy Spreadsheet e Sicurezza: guida definitiva per acquisti protetti',
    excerpt: 'Tutto quello che devi sapere sulla sicurezza negli acquisti internazionali: controllo qualità, metodi di pagamento e protezione dei dati.',
    badge: 'Sicurezza',
  },
  {
    slug: '/come-usare-itaobuy-principianti',
    image: 'https://readdy.ai/api/search-image?query=Beginner%20friendly%20workspace%20with%20simple%20notebook%20and%20colorful%20product%20swatches%20on%20light%20warm%20gray%20background%2C%20soft%20natural%20light%2C%20welcoming%20editorial%20style&width=600&height=340&seq=seo-card-03&orientation=landscape',
    title: 'Come usare Itaobuy Spreadsheet: guida completa per principianti',
    excerpt: 'I primi passi nel mondo di Itaobuy: configurazione del tuo foglio, ricerca prodotti e consigli pratici per iniziare con il piede giusto.',
    badge: 'Principianti',
  },
  {
    slug: '/strategie-ricerca-prodotti',
    image: 'https://readdy.ai/api/search-image?query=Professional%20data%20analysis%20with%20product%20charts%20and%20comparison%20tools%20on%20light%20warm%20background%2C%20modern%20minimalist%20style%2C%20clean%20editorial%20photography&width=600&height=340&seq=seo-card-04&orientation=landscape',
    title: 'Strategie di ricerca prodotti con Itaobuy: metodi avanzati',
    excerpt: 'Tecniche professionali per ottimizzare le tue ricerche: analisi trend, filtri avanzati e matrice decisionale per risultati migliori.',
    badge: 'Avanzato',
  },
  {
    slug: '/errori-comuni-itaobuy',
    image: 'https://readdy.ai/api/search-image?query=Red%20warning%20signs%20and%20product%20checklist%20on%20light%20warm%20background%2C%20minimalist%20editorial%20style%2C%20emphasis%20on%20avoiding%20mistakes%2C%20clean%20composition&width=600&height=340&seq=seo-card-05&orientation=landscape',
    title: 'Errori comuni con Itaobuy: cosa evitare assolutamente',
    excerpt: 'I 5 errori più frequenti che gli utenti italiani commettono e come evitarli per risparmiare tempo, denaro e frustrazioni.',
    badge: 'Consigli Pratici',
  },
  {
    slug: '/guida-sicurezza-itaobuy',
    image: 'https://readdy.ai/api/search-image?query=Quality%20control%20inspection%20with%20product%20samples%20and%20magnifying%20glass%20on%20light%20warm%20surface%2C%20minimalist%20editorial%20style%2C%20professional%20quality%20assurance%20theme&width=600&height=340&seq=seo-card-06&orientation=landscape',
    title: 'Controllo qualità QC: come verificare i prodotti prima dell\'acquisto',
    excerpt: 'Il controllo qualità è il tuo miglior alleato: impara a leggere le immagini QC e a identificare potenziali problemi prima della spedizione.',
    badge: 'Sicurezza',
  },
  {
    slug: '/come-usare-itaobuy-principianti',
    image: 'https://readdy.ai/api/search-image?query=Step%20by%20step%20guide%20layout%20with%20numbered%20cards%20and%20product%20images%20on%20light%20oak%20background%2C%20minimalist%20editorial%20style%2C%20educational%20atmosphere&width=600&height=340&seq=seo-card-07&orientation=landscape',
    title: 'Configurare il tuo primo Itaobuy Spreadsheet: template e consigli',
    excerpt: 'Scarica il template base e impara a personalizzarlo: colonne essenziali, formule utili e struttura ottimale per ogni categoria.',
    badge: 'Principianti',
  },
  {
    slug: '/strategie-ricerca-prodotti',
    image: 'https://readdy.ai/api/search-image?query=Price%20comparison%20dashboard%20with%20product%20cards%20and%20analytics%20on%20light%20warm%20background%2C%20modern%20minimalist%20style%2C%20clean%20data%20visualization&width=600&height=340&seq=seo-card-08&orientation=landscape',
    title: 'Analisi prezzi con Itaobuy: come risparmiare sugli acquisti',
    excerpt: 'Strategie di monitoraggio prezzi, identificazione trend e tecniche per calcolare il costo totale inclusa la spedizione.',
    badge: 'Avanzato',
  },
  {
    slug: '/errori-comuni-itaobuy',
    image: 'https://readdy.ai/api/search-image?query=Checklist%20and%20green%20checkmarks%20with%20product%20catalog%20on%20light%20warm%20surface%2C%20minimalist%20editorial%20style%2C%20positive%20approach%20to%20problem%20solving&width=600&height=340&seq=seo-card-09&orientation=landscape',
    title: 'Checklist definitiva: 10 cose da fare prima di ogni acquisto',
    excerpt: 'Una checklist pratica in 10 punti per assicurarti di non dimenticare nulla prima di confermare il tuo prossimo ordine.',
    badge: 'Consigli Pratici',
  },
];

export default function SEOArticles() {
  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  return (
    <section className="py-16 md:py-24 bg-background-50 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-foreground-600 text-xs font-medium mb-4">
            Articoli SEO
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-3">
            Guide e Approfondimenti Itaobuy Spreadsheet
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            Scopri tutte le nostre guide per acquistare dalla Cina in modo intelligente e sicuro
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {seoArticles.map((article, idx) => (
            <Link
              key={idx}
              to={article.slug}
              onClick={handleClick}
              className="group block bg-background-100 rounded-2xl overflow-hidden hover:bg-accent-50/40 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-full aspect-[16/9] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                  {article.badge}
                </span>
                <h3 className="font-semibold text-foreground-800 text-sm md:text-base mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 mt-3 text-accent-600 text-xs font-medium">
                  <span>Leggi l&apos;articolo</span>
                  <i className="ri-arrow-right-line text-[10px]"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}